export enum TroubleshootMode {
    Unknown,
    FAESupport,
    Email
}

export const STR_MODE_FAE_SUPPORT: string = 'Contact IAdea support';
export const STR_MODE_EMAIL: string = 'Obtain device logs';